/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSavingsHomeAndAppletSyncEntity} from '../api'

 export const useQueryGetSavingsHomeAndAppletSyncEntity = createReactQueryHook('getSavingsHomeAndAppletSyncEntity', getSavingsHomeAndAppletSyncEntity)
